import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class GeneralPopulateService {

  constructor(private translate: TranslateService, private platform: Platform) { }

  public changeMms(loading: boolean): string {
    let stringMms: string;
    let toReturn: string;
    if (loading) {
      stringMms = this.translate.instant('general.datatable.loading');
      toReturn = `
                        <div>
                          <span> ${stringMms}</span>
                        </div>
                      `;
    } else {
      stringMms = this.translate.instant('general.datatable.noData');
      toReturn = `
                        <div>
                          <span> ${stringMms}</span>
                        </div>
                      `;
    }
    return stringMms;
  }

  public isPlatformDesktop(): boolean {
    const platformsSupperted = this.platform.platforms();
    let result: boolean;
    if (platformsSupperted.includes('desktop') || platformsSupperted.includes('tablet')) {
      result = true;
    } else {
      result = false;
    }
    return result;
  }
}
